var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.153 8.162 3.613-1.84L31 4.162v2.591L26.73 8.93l-2.067 1.052-18.39 9.37-1.024.522-1.04.53L1 22.04v-2.593l1.09-.556a2.31 2.31 0 0 0 1.254-2.23A12.693 12.693 0 0 1 23.455 5.42l-.308.158L21.08 6.63A10.39 10.39 0 0 0 5.71 17.048l17.444-8.885zM7.318 21.406 31 9.348v2.584l-1.092.556a2.31 2.31 0 0 0-1.252 2.231A12.693 12.693 0 0 1 8.543 25.961l2.242-1.143.127-.069A10.392 10.392 0 0 0 26.296 14.33l-17.46 8.898-3.613 1.84L1 27.218v-2.59l4.252-2.168 2.066-1.054z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlm);
export default __webpack_public_path__ + "static/media/XLM.5fef99b9c2b391b8ed937a4fc27d0d24.svg";
export { ForwardRef as ReactComponent };